import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { WallDecorPieceForDisplay } from 'ZalamoLibrary/src/lib/ui/look-book-front/wall-decor-front/graphql';

@Component({
    selector: 'lib-wall-decor-icon',
    templateUrl: './wall-decor-icon.component.html',
    styleUrls: ['./wall-decor-icon.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class WallDecorIconComponent implements OnInit {
  @Input() pieces: WallDecorPieceForDisplay[];
  @Input() price: string;
  constructor() {}

  ngOnInit(): void {}
}
